import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const BlueprintSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default BlueprintSVG;
